import { useActorRef, useSelector } from '@xstate/react';
import classNames from 'classnames';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { FULL_WIDTH, GRID_CONTAINER } from '~/constants/styles';
import { Completed } from './Completed';
import { NotFound } from './NotFound';
import { peerRefMachine } from './peerReferenceMachine';
import { PeerRefWizard } from './Wizard/PeerRefWizard';

export const PeerReference = () => {
  const params = useParams();
  const peerMachineRef = useActorRef(peerRefMachine, {
    input: {
      magicLink: params.magicLink,
    },
  });
  const { notFound, peerReference } = useSelector(peerMachineRef, (state) => state.context);

  useEffect(() => {
    peerMachineRef.send({ type: 'ON_GET' });
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center bg-base pt-20">
      <div className={classNames(GRID_CONTAINER, 'w-full')}>
        <div className={FULL_WIDTH}>
          <main>
            <div className="py-8">
              {notFound ? (
                <NotFound />
              ) : peerReference.referenceDate ? (
                <Completed />
              ) : (
                <PeerRefWizard actor={peerMachineRef} />
              )}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};
